/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
import { buildCollectionParam } from '../../../alfrescoApiClient';
export class PreferencesApi extends BaseApi {
    getPreference(personId, preferenceName, opts) {
        throwIfNotDefined(personId, 'personId');
        throwIfNotDefined(preferenceName, 'preferenceName');
        const pathParams = {
            personId,
            preferenceName
        };
        const queryParams = {
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/people/{personId}/preferences/{preferenceName}',
            pathParams,
            queryParams
        });
    }
    listPreferences(personId, opts) {
        throwIfNotDefined(personId, 'personId');
        const pathParams = {
            personId
        };
        const queryParams = Object.assign(Object.assign({}, (opts || {})), { fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv') });
        return this.get({
            path: '/people/{personId}/preferences',
            pathParams,
            queryParams
        });
    }
}
